import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './contexts/AuthContext';
import { DarkModeProvider } from './contexts/DarkModeContext';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Dashboard from './panel/pages/Dashboard';
import Blogs from './panel/pages/Blogs';
import BlogForm from './panel/pages/BlogForm';
import Authors from './panel/pages/Authors';
import AuthorForm from './panel/pages/AuthorForm';
import Categories from './panel/pages/Categories';
import Tags from './panel/pages/Tags';
import ContactMessages from './panel/pages/ContactMessages';
import Proposals from './panel/pages/Proposals';
import ProposalForm from './panel/pages/ProposalForm';
import Documents from './panel/pages/Documents';
import DocumentForm from './panel/pages/DocumentForm';
import Projects from './panel/pages/Projects';
import ProjectForm from './panel/pages/ProjectForm';
import BugReports from './panel/pages/BugReports';
import Apps from './panel/pages/Apps';
import AppForm from './panel/pages/AppForm';
import DateInvites from './panel/pages/DateInvites';
import Polls from './panel/pages/Polls';

function App() {
   return (
      <DarkModeProvider storageKey="adminDarkMode">
         <AuthProvider>
            <Toaster
               position="top-center"
               toastOptions={{
                  duration: 3000,
                  style: {
                     borderRadius: '8px',
                     padding: '12px 16px',
                     fontSize: '14px',
                  },
                  success: {
                     duration: 3000,
                  },
                  error: {
                     duration: 4000,
                  },
               }}
            />
            <BrowserRouter>
               <Routes>
                  {/* Login Route - Public */}
                  <Route path="/login" element={<Login />} />

                  {/* Admin Panel Routes - Protected */}
                  <Route
                     path="/admin"
                     element={
                        <ProtectedRoute>
                           <Dashboard />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/blogs"
                     element={
                        <ProtectedRoute>
                           <Blogs />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/blogs/new"
                     element={
                        <ProtectedRoute>
                           <BlogForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/blogs/:id"
                     element={
                        <ProtectedRoute>
                           <BlogForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/authors"
                     element={
                        <ProtectedRoute>
                           <Authors />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/authors/new"
                     element={
                        <ProtectedRoute>
                           <AuthorForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/authors/:id"
                     element={
                        <ProtectedRoute>
                           <AuthorForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/categories"
                     element={
                        <ProtectedRoute>
                           <Categories />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/tags"
                     element={
                        <ProtectedRoute>
                           <Tags />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/contact-messages"
                     element={
                        <ProtectedRoute>
                           <ContactMessages />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/date-invites"
                     element={
                        <ProtectedRoute>
                           <DateInvites />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/polls"
                     element={
                        <ProtectedRoute>
                           <Polls />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/proposals"
                     element={
                        <ProtectedRoute>
                           <Proposals />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/proposals/new"
                     element={
                        <ProtectedRoute>
                           <ProposalForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/proposals/:id"
                     element={
                        <ProtectedRoute>
                           <ProposalForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/documents"
                     element={
                        <ProtectedRoute>
                           <Documents />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/documents/new"
                     element={
                        <ProtectedRoute>
                           <DocumentForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/documents/:id"
                     element={
                        <ProtectedRoute>
                           <DocumentForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/projects"
                     element={
                        <ProtectedRoute>
                           <Projects />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/projects/new"
                     element={
                        <ProtectedRoute>
                           <ProjectForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/projects/:id"
                     element={
                        <ProtectedRoute>
                           <ProjectForm />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/apps"
                     element={
                        <ProtectedRoute>
                           <Apps />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/apps/new"
                     element={
                        <ProtectedRoute>
                           <AppForm />
                        </ProtectedRoute>
                     }
                  />
                  <Route
                     path="/admin/apps/:id"
                     element={
                        <ProtectedRoute>
                           <AppForm />
                        </ProtectedRoute>
                     }
                  />

                  <Route
                     path="/admin/bug-reports"
                     element={
                        <ProtectedRoute>
                           <BugReports />
                        </ProtectedRoute>
                     }
                  />

                  {/* Redirect /admin/* to /admin if not found */}
                  <Route path="/admin/*" element={<Navigate to="/admin" replace />} />

                  {/* Default redirect to login */}
                  <Route path="*" element={<Navigate to="/login" replace />} />
               </Routes>
            </BrowserRouter>
         </AuthProvider>
      </DarkModeProvider>
   );
}

export default App;
